import { filtersToParams } from 'selectors/app';
import strings from 'strings';
import { AllFiltersDefinition } from 'UI/components/templates/SideFiltersLayout/filters';
import { FilterType, MONTHS } from 'UI/constants/defaults';
import { getTodayDate } from 'UI/utils';

export const getExtraFilters = yearFilterOptions => {
  const [currentYear, currentMonth] = getTodayDate().split('-');
  const years = yearFilterOptions.map(year => ({
    id: year,
    title: year.toString()
  }));

  return [
    {
      name: 'years',
      paramName: 'year',
      title: 'Year',
      type: FilterType.Autocomplete,
      getOptionLabel: ({ title }) => title,
      defaultValue: { id: currentYear, title: currentYear },
      options: years
    },
    {
      ...AllFiltersDefinition.find(({ name }) => name === 'months'),
      defaultValue: MONTHS.find(({ extendedId }) => extendedId === currentMonth)
    }
  ];
};

export const getMonthParam = (years, months) => {
  const [currentYear, currentMonth] = getTodayDate().split('-');
  const year = years?.value?.id ?? currentYear;
  const month = months?.value?.extendedId ?? currentMonth;

  return `${year}-${month}-01`;
};

export const formatFallOffsBoardFilters = (filters = {}) => {
  const { years, months, ...rest } = filters;

  return { ...filtersToParams(rest), month: getMonthParam(years, months) };
};

export const formatFallOffsResponse = response => {
  if (!response || !Array.isArray(response?.data)) return null;

  const gpacRow = {
    company: strings.dashboard.shared.gpac
  };

  const data = response.data.map(row => {
    const weekKey = `weekOfMonth-${row.weekOfMonth}`;
    gpacRow[weekKey] = (gpacRow[weekKey] || 0) + row.total;

    return { ...row, [weekKey]: row.total };
  });

  return {
    ...response,
    data: {
      data: [gpacRow, ...data]
    }
  };
};

export const formatTransactionByWeekResponse = response => {
  if (!response || !Array.isArray(response)) return null;

  const formattedData = response.map(row => {
    const weekKey = `weekOfMonth-${row.weekOfMonth}`;

    return {
      ...row,
      company: row.recruiterName,
      industry: row.managerName,
      transactionName: row.status,
      [weekKey]: row.total
    };
  });

  return formattedData;
};

export const formatFallOffsByRecruiterResponse = response => {
  if (!response || !Array.isArray(response?.data)) return null;

  const { data } = response;
  const total = data.reduce((sum, row) => sum + row.total, 0);

  const gpacRow = {
    recruiterName: strings.dashboard.shared.gpac,
    total
  };

  return {
    ...response,
    data: {
      data: [gpacRow, ...data]
    }
  };
};

export const formatTransactionByRecruiterResponse = response => {
  if (!response || !Array.isArray(response)) return null;

  const formattedData = response.map(row => {
    return {
      ...row,
      recruiterName: row.transactionName
    };
  });

  return formattedData;
};
